import { getCountryByUrl } from '@/main/hooks/useCountryByUrl'

export const validateCountryIsEnableToNewOCR = () => {
    const countryEnable = process.env.ENABLE_NEW_OCR_TO_COUNTRY?.split(',').map(item => item.trim())
    return countryEnable.includes(getCountryByUrl())
} 